/**
 * @param {function} callback
 */
export const onEscapeKeyPress = (event, callback) => {
  if (event.keyCode === 27) {
    callback()
  }
};
